<template>
  <div class="query-form-box">
    <el-form
      :model="queryForm"
      :rules="rules"
      ref="queryForm"
      class="public-form-primary"
      label-width="80px"
    >
      <el-form-item label="检索范围：" prop="dataSetId">
        <el-select
          size="small"
          class="primary-select"
          :popper-append-to-body="false"
          placeholder="请选择构件查询范围(仅BIM数据)"
          v-model="queryForm.dataSetId"
        >
          <el-option
            v-for="(item, index) in dataSetList"
            :key="index"
            :title="item.dataSetName"
            :label="item.dataSetName"
            :value="item.dataSetId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="构件名称：">
        <div class="query-form-item-box">
          <div class="select-box">
            <el-select
              size="small"
              class="primary-select"
              placeholder="请选择查询类型"
              v-model="queryForm.range"
              :popper-append-to-body="false"
            >
              <el-option value="equals">等于</el-option>
              <el-option value="includes">包含</el-option>
            </el-select>
          </div>
          <div class="input-box">
            <el-select
              size="small"
              class="primary-select"
              v-model="queryForm.elemName"
            >
              <el-option
                v-for="(item, index) in elemNameList"
                :key="index"
                :title="item.dataSetName"
                :label="item.dataSetName"
                :value="item.dataSetId"
              />
            </el-select>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="params-query-box">
      <div class="title-box dialog-label">属性查询条件</div>
      <div
        class="params-list-box"
        v-for="(item, index) in paramsList"
        :key="index"
      >
        <div class="params-item-box">
          <div class="input-box">
            <el-input
              size="small"
              class="input-primary"
              v-model="item.elemName"
              placeholder="请输入属性名称"
            />
          </div>
          <div class="select-box">
            <el-select
              size="small"
              class="primary-select"
              placeholder="请选择查询类型"
              v-model="item.range"
            >
              <el-option value="equals">等于</el-option>
              <el-option value="includes">包含</el-option>
            </el-select>
          </div>
          <div class="select-box">
            <el-select
              size="small"
              class="primary-select"
              :popper-append-to-body="false"
              placeholder="请输入属性值"
              v-model="item.value"
            >
              <el-option value="equals">等于</el-option>
              <el-option value="includes">包含</el-option>
            </el-select>
          </div>
          <div class="action-btn-box">
            <i class="el-icon-circle-plus-outline" />
            <i class="el-icon-remove-outline" />
          </div>
        </div>
      </div>
    </div>
    <div class="query-btn-box">
      <el-button class="primary-btn" size="small" @click="query">
        查询
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        dataSetId: "",
        range: "",
        elemName: "",
      },
      elemNameList: [],
      paramsList: [{ paramName: "", range: "", value: "" }],
      rules: {
        dataSetId: [
          {
            required: true,
            message: "请选择构件查询范围(仅BIM数据)",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    dataSetList: Array,
    closeDialog: Function,
  },
  methods: {
    query() {},
  },
};
</script>

<style lang="less" scoped>
.query-form-box {
  .public-form-primary {
    padding: 16px 16px 0px 16px;
    :deep(.el-form-item) {
      margin-bottom: 16px;

      .el-form-item__label {
        padding: 0px;
        height: 32px;
        line-height: 32px;

        &::before {
          margin-right: 2px;
        }
      }

      .el-form-item__content{
        line-height: 32px;
      }

      .el-select {
        width: 100%;
      }
    }

    .query-form-item-box {
      display: grid;
      grid-template-columns: 2fr 5fr;
      gap: 10px;
    }
  }

  .params-query-box {
    margin: 0px 16px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid var(--base-border-dark-color14);

    .params-list-box {
      margin-top: 8px;

      .params-item-box {
        display: grid;
        grid-template-columns: 4fr 2fr 4fr 1fr;
        align-items: center;
        gap: 10px;

        .action-btn-box {
          display: flex;
          justify-content: space-around;

          i {
            cursor: pointer;
            font-size: 20px;
            color: var(--base-dark19-color);
            &:hover{
              color: var(--base-primary-bgColor);
            }
          }
        }
      }
    }
  }

  .query-btn-box {
    margin-top: 16px;
    padding: 16px;
    text-align: right;
    border: 1px solid var(--base-border-dark-color14);

    .primary-btn {
      border-radius: 4px;

      &:hover {
        color: #fff;
        background: var(--base-bg-light-color40);
      }

      &:active {
        color: #fff;
        background: var(--base-bg-light-color40);
      }

      &:focus {
        color: #fff;
        background: var(--base-bg-light-color40);
      }
    }
  }
}
</style>